import { SwitcherGranularityContainer } from "app/pages/website-analysis/components/SwitcherGranularityContainer";

export const TimeGranularitySwitcher = ({ timeGranularity, granularityUpdate, getGranularity }) => {
    return (
        <div data-automation="time-granularity-switcher">
            <SwitcherGranularityContainer
                itemList={getGranularity()}
                selectedIndex={getGranularity().findIndex((ga) => ga.name === timeGranularity.name)}
                onItemClick={granularityUpdate}
                customClass={"CircleSwitcher"}
            />
        </div>
    );
};
